module.exports = __webpack_public_path__ + "media/images/countrysquared/ag-fcf36c924d407f0ecdc328e6fbbec0e3.svg";